import styled from 'styled-components';

export default function LivePreviewState({ status, title, onBrowse }: {
  status?: string;
  title?: string;
  onBrowse: () => void;
}) {
  const ended = status === '종료';
  const cancelled = status === '취소';
  const waiting = status === '예약';
  return <State role="status" aria-live="polite">
    <Symbol aria-hidden="true">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="6" width="28" height="20" rx="5" />
        <path d="M13 31h10M18 26v5" />
        {ended ? <path d="m12 16 4 4 8-8" /> : <path d="m15 12 8 4-8 4z" />}
      </svg>
    </Symbol>
    <div>
      <h2>{cancelled ? '방송이 취소되었습니다.' : ended ? '방송이 종료되었습니다.' : waiting ? '방송 대기 중입니다.' : '방송 정보를 불러오는 중입니다.'}</h2>
      <p>{cancelled ? '취소된 방송은 송출할 수 없습니다.\n라이브 목록에서 다른 방송을 선택해주세요.' : ended
        ? '등록된 상품과 주문 내역은\n방송 종료 후에도 확인할 수 있습니다.'
        : waiting ? '리허설이나 라이브 송출을 시작하면\n이곳에 영상이 표시됩니다.' : '잠시만 기다려주세요.'}</p>
    </div>
    {title && <BroadcastTitle><span>{cancelled ? '취소된 방송' : ended ? '종료된 방송' : '예정된 방송'}</span><strong>{title}</strong></BroadcastTitle>}
    {(ended || cancelled) && <BrowseButton type="button" onClick={onBrowse}>라이브 목록으로</BrowseButton>}
  </State>;
}

const State = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 360px;
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  background: var(--admin-theme-raised, #f7f5fa);
  color: var(--admin-theme-text, #292433);
  text-align: center;
  h2 { margin: 0; font: var(--font-weight-semibold) 20px/1.45 var(--font-family-base); word-break: keep-all; }
  p { margin: 12px 0 0; font-size: 14px; line-height: 1.75; white-space: pre-line; color: var(--admin-theme-muted, #716a7c); word-break: keep-all; }
  @media (max-width: 380px) { padding: 28px 16px; h2 { font-size: 18px; } }
`;

const Symbol = styled.div`
  display: grid;
  place-items: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--admin-theme-accent-soft, #ede6fd);
  color: var(--admin-theme-link, #6941d9);
`;

const BroadcastTitle = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding-top: 20px;
  border-top: 1px solid var(--admin-theme-border, #e7e2ee);
  span { display: block; margin-bottom: 6px; font-size: 12px; color: var(--admin-theme-muted, #716a7c); }
  strong { display: block; font: var(--font-weight-medium) 14px/1.5 var(--font-family-base); overflow-wrap: anywhere; }
`;

const BrowseButton = styled.button`
  min-height: 44px;
  padding: 10px 20px;
  border: 1px solid var(--admin-theme-border, #ddd5ed);
  border-radius: 8px;
  background: var(--admin-theme-surface, #fff);
  color: var(--admin-theme-link, #6941d9);
  font: var(--font-weight-semibold) 14px/1.5 var(--font-family-base);
  cursor: pointer;
  &:hover { background: var(--admin-theme-accent-soft, #ede6fd); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #6941d9); outline-offset: 3px; }
`;
